import moment from 'moment'

export default function validations() {
    /**
     * @constant requiredValidation si el valor insertado NO es undefined devuelve true, de lo contrario devolverá false.
     * Con esta constante se averigua si el valor del campo que se envía a través del @param {*} getVal está vacío o no. 
     */
    /**
     * @constant objValidations contiene las expresiones regulares que se pasarán por parámetro en la @constant validation
     * para la validación de los campos.
           */
    const objValidations = {
      email: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
      dni: /^\d{8}[a-zA-Z]$/, 
      nie: /^[XxTtYyZz]{1}[0-9]{7}[a-zA-Z]{1}$/,
      cif: /^[a-zA-Z]{1}\d{7}[a-zA-Z0-9]{1}$/,
      codigoPostal: /^(?:0[0-9]\d{3}|[1-4]\d{4}|5[0-2]\d{3})$/,
      numeric: /^[0-9]{1,5}$/,
      numPiso: /^[0-9]{1,3}$/,
      mobilePhone: /^\+[0-9 ]{0,16}$/,
      mobileEspana: /^(?:\+34|\+034)[ ]?(?:6|7)[0-9 ]*$/,
      phone: /^(9|8)[ -]*([0-9][ -]*){8}$/,
      birthdate: /^([0][1-9]|[12][0-9]|3[01])(\/|-)([0][1-9]|[1][0-2])\2(\d{4})$/,
      empty: /^[^]+$/,
    }
    const requiredValidationUndefined = (getVal) => {
      return (
        getVal !== undefined  ? true : false
      )
    }
    const requiredValidationSelects = (getVal) => {
      return (
        (getVal === '' || getVal === undefined || getVal === null) ? false : true
      )
    }
    const validation = (getVal, typeValidation) => {
      return (
        typeValidation.test(getVal) ? true : false
      )
    }
    const validationDate = (getVal, typeValidation) => {
      let isValid = false;

      if(validation(getVal, typeValidation)){
        let todayDate = new Date();

        var birthdateMoment = moment(getVal, "DD/MM/YYYY"); 
        var birthdateDate = birthdateMoment.toDate();

        if(birthdateDate<todayDate){
          isValid=true;
        }
      }

      return isValid;
    }
    return { validation, objValidations, requiredValidationSelects, requiredValidationUndefined, validationDate };
  }